export default __webpack_public_path__ + "static/media/s-local.aeecc6ac.jpeg";